<template>
    <!-- We have this div to prevent spacings used as default for OperationsWrapper -->
    <div class="align-helper">
        <!-- Icon -->
        <open-bank-account style="margin-bottom: 8px"/>
        <!-- Title -->
        <div class="title">{{t('join.createAccount.mobileInfoPage.title')}}</div>
        <!-- Text -->
        <div class="text">{{t('join.createAccount.mobileInfoPage.text')}}</div>
        <!-- *********************************************
        *                    List of Info                *
        ********************************************** -->
        <!-- Item 1 -->
        <text-block-list isNumbered :list="textBlockListItens">
            <template #item-slot-1>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item1.bulletDescription')}}</div>
            </template>
            <template #item-slot-2>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item2.bulletDescription')}}</div>
                <text-block-list :list="textBlockListSubItens"/>
            </template>
            <template #item-slot-3>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item3.bulletDescription')}}</div>
            </template>
            <template #item-slot-4>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item4.bulletDescription')}}</div>
            </template>
            <template #item-slot-5>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item5.bulletDescription')}}</div>
            </template>
            <template #item-slot-6>
                <div class="bullet-description">{{t('join.createAccount.mobileInfoPage.item6.bulletDescription')}}</div>
            </template>
        </text-block-list>
    </div>
</template>

<script setup>
import OpenBankAccount from '@/assets/icons/illustrations/open-bank-account.svg?inline'
import TextBlockList from '@/components/generic/textBlocks/List'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const textBlockListItens = [
    t('join.createAccount.mobileInfoPage.item1.bulletTitle'),
    t('join.createAccount.mobileInfoPage.item2.bulletTitle'),
    t('join.createAccount.mobileInfoPage.item3.bulletTitle'),
    t('join.createAccount.mobileInfoPage.item4.bulletTitle'),
    t('join.createAccount.mobileInfoPage.item5.bulletTitle')
]

const textBlockListSubItens = [
    t('join.createAccount.mobileInfoPage.item2.subitems1'),
    t('join.createAccount.mobileInfoPage.item2.subitems2'),
    t('join.createAccount.mobileInfoPage.item2.subitems3')
]
</script>

<style lang="scss" scoped>
.title {
    width: 100%;
    margin-bottom: 16px;

    @include H2-Medium;
    color: var(--primary);
}

.text {
    width: 100%;
    margin-bottom: 32px;

    @include H5-Regular;
    color: var(--secondary-dark-3);
    line-height: 20px;
}

.text-block-bullet-list {
    gap: 24px;

    .slot-wrapper {
        .bullet-description {
            width: 100%;

            @include H6-Regular;
            color: var(--secondary-dark-2);
            line-height: 18px;
        }
    }

    .text-block-bullet-list {
        margin-top: 8px;
        gap: 8px;
    }
}
</style>
